export default "__VITE_ASSET__C9njIeUp__"